<template>
	<div style="display:flex;">
		<dropdown-menu
			v-if="appsorg.length > 0"
            v-model="show"
            :right="right"
            :hover="hover" class="dropAppsArea"
            style="margin-left: 10px;"
        >
			<button class="btnDrop btnListApps">
				<span class="Apps-icon-Left">
					<img class="menuapps" alt="menuapps" src="@/core/assets/img/menuapps.svg" />
				</span>
			</button>
			<div slot="dropdown" class="appslist">
				<div class="AreaDropItems">
					<div class="title_app_header">All Apps</div>
					<a
						@click="linkApps(i.id,index)"
						v-for="(i,index) in appsorg"
						:key="index" 
						v-bind:class="['dropdown-item iconapps', (i.statusApp==3) ? 'novisible ' : '']"
						v-if="i.assingStatus!=0 && i.statusApp!=3"
					>
						<span v-if="i.statusApp<3">
							<img :alt="i.name" :src="imgIconMenu(i)" :class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']" />
							<!-- <img alt="billing" v-if="i.id==1" src="@/core/assets/img/icon_billing.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="project"  v-else-if="i.id==3" src="@/core/assets/img/icon_project.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="sites"  v-else-if="i.id==2" src="@/core/assets/img/icon_sites.svg"  style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="jobs"  v-else-if="i.id==4" src="@/core/assets/img/icon_jobs.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="calculator" v-else-if="i.id==5" src="@/core/assets/img/icon_calculator.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="slabs"  v-else-if="i.id==7" src="@/core/assets/img/icon_slabs.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="marketea"  v-else-if="i.id==8" src="@/core/assets/img/icon_bsite.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="display"  v-else-if="i.id==10" src="@/core/assets/img/icon_display.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="dimenu"  v-else-if="i.id==11" src="@/core/assets/img/icon_dimenu.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="dimenu"  v-else-if="i.id==14" src="@/core/assets/img/icon_crm.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="dimenu"  v-else-if="i.id==15" src="@/core/assets/img/icon_bRem.svg" style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']">
							<img alt="otro"  v-else  src="@/core/assets/img/icon_auxiliar.svg"  style="height:50px;" v-bind:class="[(i.statusApp==2 || i.assingStatus==0) ? 'disabled ' : '']"> -->
							<!--<img alt="otro" v-bind:class="{disabled: OrgPlan}" v-else  src="@/core/assets/img/icon_auxiliar.svg"  style="height:50px;">-->
						</span>
						<!-- <div v-if="i.id==6">Cars</div> -->
						<div v-if="i.statusApp<3">
							<span class="nameAppIcon" v-if="i.id==8">bSite</span>
							<span class="nameAppIcon" v-else>{{ i.name }}</span>
						</div>
					</a>
				</div>
			</div>
		</dropdown-menu>
		<router-link :to="{name:'Home'}" style="" class="link-home-main">
			<img class="logo" alt="Marketea" src="@/core/assets/img/new-icons/marketea_blanco.svg" />
		</router-link>
		<div class="menu_access_quisks" >
			<template v-for="app in access_quisks">
				<template v-for="(item, index) in appsorg">
					<a v-if="app.id == item.id && item.assingStatus!=0 && item.statusApp!=3" :key="index"
						@click="linkApps(item.id, 0)"
						:class="['quick-access-icon', (item.statusApp==3) ? 'novisible ' : '']"
					>
						<span v-if="item.statusApp<3">
							<img :alt="item.name" :class="[(item.statusApp==2 || item.assingStatus==0) ? 'disabled ' : '']" :src="imgIcon(item)">
						</span>
					</a>
				</template>
			</template>
		</div>
	</div>
</template>

<script>
	import DropdownMenu from '@innologica/vue-dropdown-menu'
	import { mapGetters } from 'vuex'
	export default {
		name: 'menuApps',
		components: {
			DropdownMenu
		},
		data () {
			return {
				isLoading: false,
				show: false,
				right: true,
				hover: false,
				appsorg: [],
				newListApps: [],
				OrgPlan : (window.OrgPlan <= 1),
				statusPlanBilling: 1,
				access_quisks: [
					{name: "Smart Office", id:"1"},
					{name: "bSales", id:"14"},
					{name: "Projects", id:"3"},
					{name: "bSite", id:"8"},
					{name: "Jobs", id:"4"},
					{name: "RoofCal", id:"5"},
					{name: "Sites", id:"2"},
					// {name: "bRem", id:"15"},
					// {name: "Slabs", id:"7"},
					// {name: "Display", id:"10"},
					// {name: "Tutor", id:"13"},
				]
			}
		},
		created(){
			this.appsorg = this.$store.getters['core/apps/applistorgs'];
			this.statusPlanBilling = localStorage.getItem('statusBilling');
			// console.log('created menuApps', this.appsorg);
		},
		methods: {
			homeAccount() {
				console.log('volver a dash');
				localStorage.setItem('appIDactual', 0);
				this.$store.commit('core/apps/SetAppIDactual');
				this.$router.push({name: 'Home' });
			},
			linkApps(app_id, index) {
				//if(window.OrgPlan > 1 || this.appsorg[index].id == 1){
					if(!this.appsorg[index].privilegies) {
						let msj = this.$store.getters["core/apps/getMsgAccessDeneid"];
						this.$store.commit("core/setAlertSimple", {
							icon: 'error',
							title: msj.title,
							text: msj.msg,
							showConfirmButton: false,
							timer: 4000,
							show: true
						});
					}
					else
					{
						let continuar = true;
						this.$store.dispatch("core/apps/getAppStatus", this.appsorg[index].id).then(r => {
							console.log('getAppStatus', r);
							if(r.appStatus < 1){
								continuar = false; // cambiar a false para bloquear acceso
								let name = this.appsorg[index].name;
								let msj = this.$store.getters["core/apps/getMsgAccessSuspended"];
								let msg = msj.msg.replace('[nameApp]', name);
								this.$store.commit('core/setNotiPush', {
									title: msj.title,
									text: msg,
									show: true,
									group: "notiPush",
									type: '5', // 1=success|2=info|3=error|4=loading|5=warning
									duration: 15000
								});
							}
							if(continuar){
								console.log('linkApps', this.appsorg[index]);
								this.$store.commit('set_isLoading', true);
								let app = {app_id, index};
								this.$store.dispatch('core/apps/linkApp', app).then(r => {
									console.log(r);
									if (r.status) {
										console.log('eliminar appStart');
										localStorage.removeItem('appStart');
										localStorage.setItem('nameApp', r.nomApp);
										this.$router.push({name: r.nomApp });
									}
								})
								.catch(error => {
									console.log(error);
								});
							}
						});
					}
				//}else{
				//	this.$store.commit('core/session/setShowPopPremium', {show: true, data: []});
				//}
			},
			imgIcon(item){
				let t = this;
				let src=null;
				if(item.id==1){src=require("@/core/assets/img/icons-barmenu/1.svg");}
				else if(item.id==2){src=require("@/core/assets/img/icons-barmenu/5.svg");}
				else if(item.id==3){src=require("@/core/assets/img/icons-barmenu/3.svg");}
				else if(item.id==4){src=require("@/core/assets/img/icons-barmenu/6.svg");}
				else if(item.id==5){src=require("@/core/assets/img/icons-barmenu/4.svg");}
				else if(item.id==7){src=require("@/core/assets/img/icon_slabs.svg");}
				else if(item.id==8){src=require("@/core/assets/img/icons-barmenu/2.svg");}
				else if(item.id==9){src=require("@/core/assets/img/icon_dimenu.svg");}
				else if(item.id==10){src=require("@/core/assets/img/icon_display.svg");}
				else if(item.id==13){src=require("@/core/assets/img/icon_sites.svg");}
				else if(item.id==14){src=require("@/core/assets/img/icons-barmenu/7.svg");}
				else if(item.id==15){src=require("@/core/assets/img/icon_bRem.svg");}
				else{src=require("@/core/assets/img/icon_auxiliar.svg");}
				return src;
			},
			imgIconMenu(item){
				let t = this;
				let src=null;
				if(item.id==1){src=require("@/core/assets/img/new-icons/smart-office.svg");}
				else if(item.id==2){src=require("@/core/assets/img/new-icons/sites.svg");}
				else if(item.id==3){src=require("@/core/assets/img/new-icons/projects.svg");}
				else if(item.id==4){src=require("@/core/assets/img/new-icons/jobs.svg");}
				else if(item.id==5){src=require("@/core/assets/img/new-icons/roofcal.svg");}
				else if(item.id==7){src=require("@/core/assets/img/new-icons/slabs.svg");}
				else if(item.id==8){src=require("@/core/assets/img/new-icons/bsite.svg");}
				else if(item.id==9){src=require("@/core/assets/img/icon_dimenu.svg");}
				else if(item.id==10){src=require("@/core/assets/img/new-icons/display.svg");}
				else if(item.id==13){src=require("@/core/assets/img/new-icons/sites.svg");} // tutor
				else if(item.id==14){src=require("@/core/assets/img/new-icons/bsales.svg");}
				else if(item.id==15){src=require("@/core/assets/img/new-icons/bRem.svg");}
				else{src=require("@/core/assets/img/new-icons/marketea_azul.svg");}
				return src;
			},
		},
		watch: {
			'getAppsorg': function(){
				this.appsorg = this.getAppsorg;
				// console.log('watch menuApps', this.appsorg);
			},
			appsorg: function(){
				this.newListApps = this.appsorg;
			},
	        accitonPusher: function () {
	            let t = this;
	            if (t.accitonPusher != undefined) 
	            {
	            	if(t.accitonPusher.action === "statusBilling")
	            	{
                    	let data = t.accitonPusher.data;
                    	if(window.localorgdata == data.org_id && window.localAccountID == data.user_id){
							t.statusPlanBilling = data.statusBilling
							localStorage.setItem('statusBilling', data.statusBilling);
							console.log('accitonPusher statusBilling', t.statusPlanBilling);
                    	}
                	}
            	}
            },
		},
		computed: {
			...mapGetters("core", {accitonPusher: "get_accitonPusher"}),
			...mapGetters('core/apps', {getAppsorg : 'applistorgs'}),
			...mapGetters('core/apps', {getAppID : 'getAppIDactual'}),
		}
	};
</script>
<style lang="scss" scoped>
	a.dropdown-item.iconapps span img {
		width: 60px;
		height: 60px;
	}
	a.dropdown-item.iconapps img.disabled {
		opacity: 0.4;
	}
	a.dropdown-item.iconapps.novisible{
		display: none;
	}
	.nameAppIcon {
		font-size: 0.75rem;
		font-family: "Open Sans", sans-serif;
		font-weight: 200;
		color: #000;
		margin: 10px auto;
		text-align: center;
		}
	.menu_access_quisks {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0px 10px;
		margin-left: 60px;
		@media (max-width: 767px) {
			display: none;
		}
	}
	a.quick-access-icon {
		padding: 0 10px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		box-sizing: content-box;
		@media (max-width: 767px) {
			display: none;
		}
		&:hover {
			cursor: pointer;
			background-color: #000;
		}
		span {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			img {
				width: auto;
				height: 35px;
				fill: #fff;
				border-radius: 8px;
				@media (max-width: 991px) {
					width: 30px;
				}
			}
		}
	}
</style>
